import { Routes } from '@angular/router';

import { authGuard, guestGuard } from './core/auth/auth.guard';
import { AuthComponent } from './pages/auth/auth';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  // /auth fica eager: é a landing page, sem fetch extra de chunk.
  { path: 'auth', canActivate: [guestGuard], component: AuthComponent },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard-layout').then((m) => m.DashboardLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-overview').then((m) => m.DashboardOverviewComponent),
      },
      {
        path: 'clientes/:companyId/configuracoes',
        loadComponent: () =>
          import('./pages/dashboard/clients/company-workspace-placeholder.component').then(
            (m) => m.CompanyWorkspacePlaceholderComponent,
          ),
        data: { title: 'Configurações' },
      },
      {
        path: 'clientes/:companyId/perfis',
        loadComponent: () =>
          import('./pages/dashboard/clients/company-profiles-page.component').then(
            (m) => m.CompanyProfilesPageComponent,
          ),
      },
      {
        path: 'clientes/:companyId/usuarios',
        loadComponent: () =>
          import('./pages/dashboard/clients/company-users-page.component').then(
            (m) => m.CompanyUsersPageComponent,
          ),
        data: { title: 'Gerenciar usuários' },
      },
      {
        path: 'clientes/:companyId/integracoes',
        loadComponent: () =>
          import('./pages/dashboard/clients/company-integrations-page.component').then(
            (m) => m.CompanyIntegrationsPageComponent,
          ),
        data: { title: 'Integrações' },
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./pages/dashboard/clients/clients-page').then((m) => m.ClientsPageComponent),
      },
      {
        path: 'fabricantes',
        loadComponent: () =>
          import('./pages/dashboard/manufacturers/manufacturers-page').then(
            (m) => m.ManufacturersPageComponent,
          ),
      },
      {
        path: 'revendedores',
        loadComponent: () =>
          import('./pages/dashboard/resellers/resellers-page').then(
            (m) => m.ResellersPageComponent,
          ),
      },
      {
        path: 'operadores',
        loadComponent: () =>
          import('./pages/dashboard/operators/operators-page').then(
            (m) => m.OperatorsPageComponent,
          ),
      },
      {
        path: 'parametrizacoes',
        loadComponent: () =>
          import('./pages/dashboard/parameterizations/parameterizations-page').then(
            (m) => m.ParameterizationsPageComponent,
          ),
      },
      {
        path: 'menus',
        loadComponent: () =>
          import('./pages/dashboard/menus/menus-page').then((m) => m.MenusPageComponent),
      },
      {
        path: 'tickets',
        loadComponent: () =>
          import('./pages/dashboard/tickets/tickets-page').then((m) => m.TicketsPageComponent),
      },
      {
        path: 'base-conhecimento',
        loadComponent: () =>
          import('./pages/dashboard/knowledge-base/knowledge-base-page').then(
            (m) => m.KnowledgeBasePageComponent,
          ),
      },
      {
        path: 'ambiencia',
        loadComponent: () =>
          import('./pages/dashboard/ambience/ambience-page').then((m) => m.AmbiencePageComponent),
      },
      {
        path: 'paletas-cores',
        loadComponent: () =>
          import('./pages/dashboard/color-palettes/color-palettes-page').then(
            (m) => m.ColorPalettesPageComponent,
          ),
      },
      {
        path: 'paletas-cores/nova',
        loadComponent: () =>
          import('./pages/dashboard/color-palettes/color-palette-form-page').then(
            (m) => m.ColorPaletteFormPageComponent,
          ),
      },
      {
        path: 'paletas-cores/:id/editar',
        loadComponent: () =>
          import('./pages/dashboard/color-palettes/color-palette-form-page').then(
            (m) => m.ColorPaletteFormPageComponent,
          ),
      },
    ],
  },
];
